// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding: 10px;
    background: #ffff;
}
.outer-card {
    border: 1px solid rgba(161, 186, 209, 1);
    border-radius: 25px;
    background-color: #f1f8ff;
    margin-bottom: 8px;
    padding: 10px;
    margin-left: 8px;
    margin-right: 8px;
}

.statistic-card {
    display: flex;
    flex-direction: row; 
    align-items: center;   
    justify-content: flex-start; 
    border-radius: 25px;
    box-shadow: 3px 4px 10px 0px rgba(0, 0, 0, 0.25);
    background-color: #ffff;
    margin: 10px 0;
    width: calc(100% - 20px);
    max-height: 80px;
    color: rgba(0, 68, 129, 1);
    border: 1px solid rgba(161, 186, 209, 1);
    text-align: center;    
}

.statistic-title {
    color: rgba(0, 68, 129, 1);
    /* font-family: Robot Flex; */
    font-weight: 600;
    margin-left: 10px; 
    text-align: left;  
    font-size: 14px;
}


.chart-container {
    display: flex; 
    align-items: flex-start; 
}

.chart-card {
    background-color: #f9f9f9; 
    border: 1px solid rgba(161, 186, 209, 1);
    border-radius: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
    margin: 10px; 
    flex: 1; 
}

.flex-container {
    display: flex; 
    align-items: flex-start; 
    background-color: #f1f8ff;
    border-radius: 25px;
}

.detail-view-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
}

.heading {
    font-size: 18px;
    font-weight: 600;
    color: rgb(1 77 78);
}

.back-button {
    margin-left: auto;
    width: 100px;
    position: relative;
    top: -10px;
}

.back-button.ant-btn-primary.ant-btn-solid {
    background: #f1f8ff;
    color: black;
}

.back-button.ant-btn-primary.ant-btn-solid:not(:disabled):not(.ant-btn-disabled):hover {
    background: rgb(1 77 78);
}

/* .statistic-title {
    color: rgba(0, 68, 129, 1);
    font-weight: 600;
    padding: 5px;
    margin: 5px;
} */

.custom-legend {
    width: 200px;
    height: auto;
    margin: 10px; 
    padding: 5px; 
    border: 2px dotted #ccc ; 
    background-color: white; 
    border-radius: 25px; 
    z-index: 10; 
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.legend-item {
    display: flex;
    align-items: center; 
    margin-bottom: 5px; 
    max-height: 50px;
}

.legend-color {
    width: 12px;
    height: 12px;
    margin-right: 5px;
}
.chart-header {
    font-weight: 600;
    margin: 10px auto;
    text-align: center;
}

@media (max-width: 576px) {
    .custom-legend {
        width: 120px;
        height: auto;
        margin: 10px; 
        padding: 5px; 
        border: 2px dotted #ccc ; 
        background-color: white; 
        border-radius: 25px; 
        z-index: 10; 
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    } 
}
.supplier-goals-table .ant-table-thead > tr > th {
    background-color: #f0f2f5;
    color: #1f405a;
    font-weight: 600;
  }
  
  .supplier-goals-table .ant-table-tbody > tr > td {
    padding: 12px 16px;
  }
  
  .supplier-goals-table .ant-table-tbody > tr:hover > td {
    background-color: rgba(0, 68, 129, 0.05);
  }
  
  /* Custom styles for the donut charts */
  .recharts-wrapper .recharts-surface {
    overflow: visible;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .chart-card .recharts-responsive-container {
      height: 120px !important;
    }
  }
  
.statistic-card {
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  .statistic-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .statistic-title {
    color: #6c757d;
    font-weight: 500;
  }
  
  .custom-legend {
    display: flex;
    flex-direction: column;
    padding: 8px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.8);
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    margin: 4px 0;
  }
  
  .legend-color {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 4px;
  }
  
  .chart-card {
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 16px;
    border: 2px solid #d1d5dc;
  }
  
  .chart-header {
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
  }
  
  .supplier-goals-table .ant-table-thead > tr > th {
    background-color: #f0f2f5;
    color: #333;
    font-weight: 600;
  }
  
  .supplier-goals-table .ant-table-tbody > tr:nth-child(even) {
    background-color: #f8fafc;
  }
  
  .supplier-goals-table .ant-table-tbody > tr:hover > td {
    background-color: #e6f7ff;
  }
  
    `, "",{"version":3,"sources":["webpack://./src/components/KpiDetailView/DetailView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gDAAgD;IAChD,uBAAuB;IACvB,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,0BAA0B;IAC1B,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;;GAKG;;AAEH;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,wBAAwB;QACxB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;IACjC;AACJ;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA,uCAAuC;EACvC;IACE,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE;MACE,wBAAwB;IAC1B;EACF;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".container {\n    padding: 10px;\n    background: #ffff;\n}\n.outer-card {\n    border: 1px solid rgba(161, 186, 209, 1);\n    border-radius: 25px;\n    background-color: #f1f8ff;\n    margin-bottom: 8px;\n    padding: 10px;\n    margin-left: 8px;\n    margin-right: 8px;\n}\n\n.statistic-card {\n    display: flex;\n    flex-direction: row; \n    align-items: center;   \n    justify-content: flex-start; \n    border-radius: 25px;\n    box-shadow: 3px 4px 10px 0px rgba(0, 0, 0, 0.25);\n    background-color: #ffff;\n    margin: 10px 0;\n    width: calc(100% - 20px);\n    max-height: 80px;\n    color: rgba(0, 68, 129, 1);\n    border: 1px solid rgba(161, 186, 209, 1);\n    text-align: center;    \n}\n\n.statistic-title {\n    color: rgba(0, 68, 129, 1);\n    /* font-family: Robot Flex; */\n    font-weight: 600;\n    margin-left: 10px; \n    text-align: left;  \n    font-size: 14px;\n}\n\n\n.chart-container {\n    display: flex; \n    align-items: flex-start; \n}\n\n.chart-card {\n    background-color: #f9f9f9; \n    border: 1px solid rgba(161, 186, 209, 1);\n    border-radius: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n    margin: 10px; \n    flex: 1; \n}\n\n.flex-container {\n    display: flex; \n    align-items: flex-start; \n    background-color: #f1f8ff;\n    border-radius: 25px;\n}\n\n.detail-view-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 5px;\n}\n\n.heading {\n    font-size: 18px;\n    font-weight: 600;\n    color: rgb(1 77 78);\n}\n\n.back-button {\n    margin-left: auto;\n    width: 100px;\n    position: relative;\n    top: -10px;\n}\n\n.back-button.ant-btn-primary.ant-btn-solid {\n    background: #f1f8ff;\n    color: black;\n}\n\n.back-button.ant-btn-primary.ant-btn-solid:not(:disabled):not(.ant-btn-disabled):hover {\n    background: rgb(1 77 78);\n}\n\n/* .statistic-title {\n    color: rgba(0, 68, 129, 1);\n    font-weight: 600;\n    padding: 5px;\n    margin: 5px;\n} */\n\n.custom-legend {\n    width: 200px;\n    height: auto;\n    margin: 10px; \n    padding: 5px; \n    border: 2px dotted #ccc ; \n    background-color: white; \n    border-radius: 25px; \n    z-index: 10; \n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center; \n    margin-bottom: 5px; \n    max-height: 50px;\n}\n\n.legend-color {\n    width: 12px;\n    height: 12px;\n    margin-right: 5px;\n}\n.chart-header {\n    font-weight: 600;\n    margin: 10px auto;\n    text-align: center;\n}\n\n@media (max-width: 576px) {\n    .custom-legend {\n        width: 120px;\n        height: auto;\n        margin: 10px; \n        padding: 5px; \n        border: 2px dotted #ccc ; \n        background-color: white; \n        border-radius: 25px; \n        z-index: 10; \n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n    } \n}\n.supplier-goals-table .ant-table-thead > tr > th {\n    background-color: #f0f2f5;\n    color: #1f405a;\n    font-weight: 600;\n  }\n  \n  .supplier-goals-table .ant-table-tbody > tr > td {\n    padding: 12px 16px;\n  }\n  \n  .supplier-goals-table .ant-table-tbody > tr:hover > td {\n    background-color: rgba(0, 68, 129, 0.05);\n  }\n  \n  /* Custom styles for the donut charts */\n  .recharts-wrapper .recharts-surface {\n    overflow: visible;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .chart-card .recharts-responsive-container {\n      height: 120px !important;\n    }\n  }\n  \n.statistic-card {\n    display: flex;\n    align-items: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n  }\n  \n  .statistic-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  .statistic-title {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .custom-legend {\n    display: flex;\n    flex-direction: column;\n    padding: 8px;\n    border-radius: 4px;\n    background-color: rgba(255, 255, 255, 0.8);\n  }\n  \n  .legend-item {\n    display: flex;\n    align-items: center;\n    margin: 4px 0;\n  }\n  \n  .legend-color {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    border-radius: 4px;\n  }\n  \n  .chart-card {\n    background-color: white;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    margin-bottom: 16px;\n    border: 2px solid #d1d5dc;\n  }\n  \n  .chart-header {\n    font-weight: 600;\n    margin-bottom: 16px;\n    color: #333;\n  }\n  \n  .supplier-goals-table .ant-table-thead > tr > th {\n    background-color: #f0f2f5;\n    color: #333;\n    font-weight: 600;\n  }\n  \n  .supplier-goals-table .ant-table-tbody > tr:nth-child(even) {\n    background-color: #f8fafc;\n  }\n  \n  .supplier-goals-table .ant-table-tbody > tr:hover > td {\n    background-color: #e6f7ff;\n  }\n  \n    "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
